import React, { useEffect, useState, useCallback } from "react";
import API_BASE_URL from "../../Constants";
import { NotificationFields } from "./config";
import { useAuth } from "../../contexts/AuthContext";





const NotificationList = () => {
    const [proposalNotification, setProposalNotification] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const { user } = useAuth();

    useEffect(() => {
        const fetchNotifications = async () => {
            setIsLoading(true);
            try {
                const response = await fetch(`${API_BASE_URL}/api/notifications/proposal`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: "include"
                });
                const data = await response.json();
                setProposalNotification(data);
            } catch (error) {
                console.error("Error fetching notifications:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchNotifications();
    }, []);


    const handleAcknowledge = async (notificationId) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/notifications/proposal/acknowledge/${notificationId}?userId=${user.id}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
            });
            const data = await response.text();
            console.log("Notification acknowledged:", data);
            alert(data);

            if (response.ok) {
                // Remove the acknowledged notification from the list.
                setProposalNotification((prev) =>
                    prev.filter((notification) => notification.id !== notificationId)
                );
            }

        } catch (error) {
            console.error("Error acknowledging notification:", error);
        }
    };





    return (
        <div className="mx-auto pl-4 pr-4 h-screen w-full">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-2xl font-bold">Notifications List</h2>

            </div>

            {/* Table */}
            {!isLoading ? (
                <table className="min-w-full bg-white rounded-lg shadow-lg overflow-hidden border-2 border-gray-200">
                    <thead className="bg-gray-200">
                        <tr>
                            {NotificationFields.map((field) => (
                                <th key={field.key} className="px-4 py-2 text-left font-bold text-blue-600">
                                    {field.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="text-gray-700">
                        {proposalNotification.map((notification) => (
                            <tr key={notification.id} className="border-t">
                                {NotificationFields.map((field) => {
                                    if (field.key === "actions") {
                                        return (
                                            <td key={field.key} className="px-4 py-2">
                                                <button className="text-blue-600" onClick={() => { handleAcknowledge(notification.id) }}>
                                                    Acknowledge
                                                </button>
                                            </td>
                                        );
                                    }
                                    return (
                                        <td key={field.key} className="px-4 py-2">
                                            {field.map ? field.map.find((opt) => opt.key === notification[field.key])?.label || notification[field.key] : notification[field.key]}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <div className="flex justify-center items-center mt-6">
                    <p>Loading...</p>
                </div>
            )}



        </div>
    );
};

export default NotificationList;
